import { NgModule } from '@angular/core';

import { CommonUIModule } from '../common-ui';

import { FilterComponent, FiltersComponent } from './filter';

@NgModule({
  declarations: [FiltersComponent, FilterComponent],
  exports: [FiltersComponent, FilterComponent],
  imports: [CommonUIModule],
})
export class FilterModule {}
